export default "__VITE_ASSET__Y21FC1Yt__"